import { useState } from "react";
import styled from "styled-components";
import ListTable from "./ListTable";
import SearchedTable from "./SearchedTable";
import SearchBar from "./SearchBar";
import PromoterRankWidgetModal from "./PromoterRankWidgetModal";
import BuilderRankWidgetModal from "./BuilderRankWidgetModal";
import { callGetApiWithAuth } from "utils/api";

export default function TableView() {
  const [searchParam, setSearchParam] = useState({
    uuid: "",
    rank_id: "",
    builder_rank_id: "",
    created_at_range: "",
    status: "",
    sort_by: "",
  });
  const [tableMode, setTableMode] = useState("list"); // list/searched
  const [selectedId, setSelectedId] = useState("");

  const [selectedRankTrackerUserId, setSelectedRankTrackerUserId] = useState();
  const [isPrTrackerModal, setIsPrTrackerModal] = useState(false);
  const [isBrTrackerModal, setIsBrTrackerModal] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const goUser = (user) => {
    setTableMode("list");
    setSelectedId(user.id);
  };

  const handleSearch = (searchParam0) => {
    setTableMode("searched");
    setSearchParam(searchParam0);
  };

  const handlePRTracker = (userId) => {
    setSelectedRankTrackerUserId(userId);
    setIsPrTrackerModal(true);
  };

  const handleBRTracker = (userId) => {
    setSelectedRankTrackerUserId(userId);
    setIsBrTrackerModal(true);
  };

  const onExportDone = (res) => {
    setIsExporting(false);
    window.open(res.data.csv_file, "_blank");
  };
  const onExportFail = () => {
    setIsExporting(false);
  };
  const handleExport = () => {
    setIsExporting(true);
    const params = {
      ...searchParam,
    };
    const q = Object.keys(params)
      .map((k) => k + "=" + params[k])
      .join("&");
    callGetApiWithAuth(
      `report/placement_list/export?${q}`,
      onExportDone,
      onExportFail
    );
  };

  return (
    <Wrapper>
      <SearchBar
        searchParam={searchParam}
        setSearchParam={setSearchParam}
        handleSearch={handleSearch}
        handleExport={handleExport}
        isExporting={isExporting}
        icon
      />
      <div className="table-white-box">
        {tableMode === "list" && (
          <ListTable
            selectedId={selectedId}
            goUser={goUser}
            onClickPRTracker={handlePRTracker}
            onClickBRTracker={handleBRTracker}
          />
        )}
        {tableMode === "searched" && (
          <SearchedTable
            searchParam={searchParam}
            goUser={goUser}
            onClickPRTracker={handlePRTracker}
            onClickBRTracker={handleBRTracker}
          />
        )}
      </div>

      {isPrTrackerModal && (
        <PromoterRankWidgetModal
          userId={selectedRankTrackerUserId}
          onCancel={() => setIsPrTrackerModal(false)}
        />
      )}
      {isBrTrackerModal && (
        <BuilderRankWidgetModal
          userId={selectedRankTrackerUserId}
          onCancel={() => setIsBrTrackerModal(false)}
        />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-bottom: 80px;
  @media (max-width: 1400px) {
    table {
      width: 1200px;
    }
  }
  .table-white-box {
    border: 1px solid #e7e5e4;
    box-shadow: 0px 0px 16px 0px #0000000a;
    border-radius: 8px;
    .panelHead {
      padding: 24px;
      .enrollerList {
        flex-wrap: wrap;
      }
      label {
        font-size: 0.8em;
      }
    }

    .table-new-wrapper {
      tr {
        th:first-child {
          border-radius: 0px !important;
        }
        th:last-child {
          border-radius: 0px !important;
        }
        .ant-table-cell {
          .content-root {
            .title {
              font-weight: 600;
            }
            .join-date {
              color: #637381;
            }
          }
        }
      }
    }
  }
  .chat-icon {
    margin-left: 12px;
    margin-top: -5px;
    cursor: pointer;
    color: ${(props) => props.theme.palette.link};
    font-size: 16px;
  }
  .subscription-yes {
    color: #3ad33a;
  }
  .subscription-no {
    color: #ff6565;
  }
  .tableUserName {
    span {
      color: #0abab5;
      font-weight: 600;
      font-size: 14px;
    }
  }
  .tableCheckButton {
    background: #0abab5;
    border-radius: 8px !important;
    padding: 0px 12px;
    border: none;
    font-weight: 700;
  }
`;
